import { MY_CONTENT_ROUTES, ROUTES } from '../../Base.constants';
import { UNRELEASED_FEATURES_ENABLED } from '../../appConfig';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';

interface UseGetUserDropdownOptionsResult {
  myContentOptions: Array<{
    link?: string;
    title: string;
    dataTestId?: string;
    isEnabled?: boolean;
    isSeparated?: boolean;
    onClick?: () => void;
  }>;
}

export default (): UseGetUserDropdownOptionsResult => {
  const { data: userPermissions } = useFetchUserPermissions();

  const myContentOptions = [
    {
      dataTestId: 'articles-link',
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.articles}`,
      title: 'Articles',
      isEnabled: userPermissions?.hasAccessToMyContentArticles(),
    },
    { dataTestId: 'watchlists-link', link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.watchlists}`, title: 'Watchlists' },
    {
      dataTestId: 'searches-link',
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.searches}`,
      title: 'Searches',
    },
    {
      dataTestId: 'covenants-link',
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.covenants}`,
      title: 'Covenants',
      isEnabled: UNRELEASED_FEATURES_ENABLED,
    },
    {
      dataTestId: 'preferences-link',
      isSeparated: true,
      link: `${ROUTES.myContent}/${MY_CONTENT_ROUTES.managePreferences}`,
      title: 'Preferences',
    },
  ];
  return {
    myContentOptions,
  };
};
